import { mediaItems } from '@/mocks/homepage';

export default function MediaSection() {
  return (
    <section id="media" className="relative w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">精彩预告</h2>
          <p className="text-sm text-foreground-600">抢先了解即将上线的精彩内容</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {mediaItems.slice(0, 2).map((item) => (
            <div key={item.id} className="group rounded-2xl overflow-hidden bg-background-100 transition-all duration-300 sm:col-span-2 lg:col-span-2">
              <div className="flex flex-col lg:flex-row">
                <div className="lg:w-3/5">
                  <div className="relative w-full aspect-video lg:h-64 overflow-hidden">
                    <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent flex items-end p-4">
                      <span className="inline-flex items-center gap-1.5 bg-background-50/90 backdrop-blur-sm rounded-full px-3 py-1 text-xs text-foreground-700 whitespace-nowrap">
                        <span className="w-4 h-4 flex items-center justify-center">
                          <i className="ri-play-circle-fill text-primary-500 text-sm"></i>
                        </span>
                        {item.duration}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="lg:w-2/5 p-5 md:p-6 flex flex-col justify-center">
                  <h3 className="text-base md:text-lg font-heading text-foreground-950 mb-2">{item.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.subtitle}</p>
                </div>
              </div>
            </div>
          ))}
          {mediaItems.slice(2).map((item) => (
            <div key={item.id} className="group rounded-2xl overflow-hidden bg-background-100 transition-all duration-300">
              <div className="relative w-full aspect-video overflow-hidden">
                <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent flex items-end p-4">
                  <span className="inline-flex items-center gap-1.5 bg-background-50/90 backdrop-blur-sm rounded-full px-3 py-1 text-xs text-foreground-700 whitespace-nowrap">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-play-circle-fill text-primary-500 text-sm"></i>
                    </span>
                    {item.duration}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-heading text-foreground-950 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-600">{item.subtitle}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}